module.exports = "/images/cover-1.jpg";